import React from 'react';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import SupplierCompanyFields from './SupplierCompanyFields';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import Step2OtherDetails from '../../../../Dashboard/Company/Employees/EnrollmentSteps/Step2OtherDetails';
import ManagerFields from '../../../../Dashboard/Contractors/SubComponents/ContractorCreateUpdateFlows/ManagerFields';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import { STEPS_SUPPLIER_EMPLOYEE_FLOW_UPDATE } from '../../Model/Model';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */
const EmployeeFlowSupplierUpdateWithExtraData = ({
    user,
    setUser,
    steps,
    activeStep,
    setActiveStep,
    handleStepChange,
    emptyFields,
    isValidDocumentId,
    setIsValidDocumentId,
    isValidEmail,
    isValidPhoneNumber,
    isValidDob,
    setIsValidDob,
    handleEmailChange,
    handlePasswordChange,
    handlePhoneNumberChange,
    handleDateChange,
    userInfoStatusList,
    getAllServiceType,
    photoPicker,
    setPhotoPicker,
    extraData,
    setExtraData,
    headersList,
    handleChange,
    disabled,
}) => {
    return (
        <StepperTabs
            id={user?.id}
            steps={steps}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            handleStepChange={handleStepChange}
            isStepOptional={(step) => step === STEPS_SUPPLIER_EMPLOYEE_FLOW_UPDATE.OTHER_DETAILS}
        >
            <StepTab index={STEPS_SUPPLIER_EMPLOYEE_FLOW_UPDATE.COMPANY_DETAILS} activeStep={activeStep}>
                <SupplierCompanyFields
                    user={user}
                    setUser={setUser}
                    emptyFields={emptyFields}
                    getAllServiceType={getAllServiceType}
                />
            </StepTab>
            <StepTab index={STEPS_SUPPLIER_EMPLOYEE_FLOW_UPDATE.MANAGER_DETAILS} activeStep={activeStep}>
                <ManagerFields
                    title='manager'
                    user={user}
                    setUser={setUser}
                    emptyFields={emptyFields}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    statusList={userInfoStatusList}
                />
            </StepTab>
            <StepTab index={STEPS_SUPPLIER_EMPLOYEE_FLOW_UPDATE.OTHER_DETAILS} activeStep={activeStep}>
                <Step2OtherDetails
                    showBtnClean={user}
                    extraData={extraData}
                    setExtraData={setExtraData}
                    headersList={headersList}
                    onChange={handleChange}
                />
            </StepTab>
            <StepTab index={STEPS_SUPPLIER_EMPLOYEE_FLOW_UPDATE.ADD_PHOTO} activeStep={activeStep}>
                <CustomPhotoPicker
                    id='fp_efsuwed_update_photo_profile'
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    actionModel={ACTION_MODEL.UPDATE}
                    accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                    showBtnCamera={true}
                    validateFace={true}
                    classWith={'w-400px'}
                    showPreview={true}
                    disabled={disabled}
                    titleModalEdit='update_photography'
                    typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                />
            </StepTab>
        </StepperTabs>
    );
};

export default EmployeeFlowSupplierUpdateWithExtraData;
